import CancelRepeatedModal from './CancelRepeatedModal'

export default CancelRepeatedModal
